import React from "react";
import { AlertTriangle, CheckCircle2, Download, ShieldCheck, XCircle } from "lucide-react";
import { downloadJson } from "../lib/utils";
import { IssueIcon, SectionHeader } from "./Primitives";
import { localizeIssue, useLocale } from "../lib/i18n";

export default function RequirementsView({ sample }) {
  const { locale, t } = useLocale();
  const [severity, setSeverity] = React.useState("all");
  const issues = sample.analysis.issues.filter((item) => severity === "all" || item.severity === severity);
  const exportReport = () => {
    downloadJson(`${sample.id}.harbor-lens-report.json`, {
      schema_version: "harbor-lens-requirements-report-1.0",
      sample: sample.id,
      generated_at: new Date().toISOString(),
      passed: sample.analysis.passed,
      issues: sample.analysis.issues,
      metrics: sample.analysis.metrics,
      model_scores: sample.runs.map((run) => ({
        model: run.modelLabel,
        final_reward: run.finalReward,
        graded_score: run.gradedScore,
        effective_score: run.effectiveScore,
        gating: run.gating,
      })),
      controls: sample.controls,
    });
  };
  return (
    <div className="page-stack">
      <section>
        <SectionHeader
          eyebrow={t("requirements.eyebrow")}
          title={t("requirements.title")}
          aside={<button className="secondary-action inline-button" onClick={exportReport}><Download size={14} />{t("requirements.export")}</button>}
        />
        <div className="requirements-hero panel">
          <div className={sample.analysis.passed ? "requirements-pass" : "requirements-fail"}>
            {sample.analysis.passed ? <CheckCircle2 size={28} /> : <XCircle size={28} />}
            <div><strong>{sample.analysis.passed ? t("requirements.pass") : t("requirements.needsWork")}</strong><span>{t("requirements.summary", { errors: sample.analysis.errors, warnings: sample.analysis.warnings })}</span></div>
          </div>
          <div className="requirements-metrics">
            <span><b>{sample.analysis.metrics.rubricCount}</b> {t("requirements.judgeGate")}</span>
            <span><b>{sample.analysis.metrics.criticalCount}</b> {t("requirements.critical")}</span>
            <span><b>{(sample.analysis.metrics.anchorRatio * 100).toFixed(0)}%</b> {t("requirements.anchors")}</span>
            <span><b>{(sample.analysis.metrics.programmaticShare * 100).toFixed(0)}%</b> {t("requirements.codeWeight")}</span>
          </div>
        </div>
      </section>

      <section>
        <div className="issue-toolbar">
          <div className="segmented">
            {["all", "error", "warning"].map((value) => (
              <button key={value} className={severity === value ? "active" : ""} onClick={() => setSeverity(value)}>{t(`requirements.${value}`)}</button>
            ))}
          </div>
          <span>{t("common.items", { count: issues.length })}</span>
        </div>
        <div className="requirements-list">
          {issues.map((item, index) => (
            <article className={`requirement-issue requirement-${item.severity}`} key={`${item.code}-${index}`}>
              <div className="requirement-icon"><IssueIcon severity={item.severity} /></div>
              <div>
                <div className="requirement-title"><code>{item.code}</code><span>{t(`requirements.severity${item.severity === "error" ? "Error" : "Warning"}`)}</span></div>
                <p>{localizeIssue(item, locale, t)}</p>
                {item.path ? <small>{item.path}</small> : null}
              </div>
            </article>
          ))}
          {!issues.length ? <div className="all-clear panel"><ShieldCheck size={22} />{t("requirements.noIssues")}</div> : null}
        </div>
      </section>
    </div>
  );
}
